enum InstitutionAccountState {
    Enabled = "ENABLED"
}
export default InstitutionAccountState